import React, { useEffect } from "react";

const ThemeProvider = ({ children }) => {
  useEffect(() => {
    const currentTheme = window.localStorage.getItem("theme");

    if (currentTheme === "dark") {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, []);

  return <>{children}</>;
};

export default ThemeProvider;
